module.exports = __webpack_public_path__ + "static/img/1-1.ec25ddb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/1-1.png
// module id = Lj9k
// module chunks = 0